import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'values' })

export class ValuesPipe implements PipeTransform {

  transform(pages: any): any {
    localStorage.setItem('localPages', JSON.stringify(pages));
    return pages;
  }
}
